import { type FC } from "react";

import { Switch } from "~/feature/event/components/SwitchGrouping/SwitchGrouping.styles";

import * as Styled from "./ToggleRow.styles";

interface IToggleRowProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const ToggleRow: FC<IToggleRowProps> = ({
  label,
  checked,
  onChange,
}) => (
  <Styled.Row>
    <Styled.Label variant="caption">{label}</Styled.Label>
    <Switch
      checked={checked}
      onChange={(_, value) => onChange(value)}
      slotProps={{ input: { "aria-label": label } }}
    />
  </Styled.Row>
);
